'use strict';

/**
 * Pict-Provider-LaneAPI
 * ---------------------
 * Browser-side client for the per-tenant board lanes (/1.0/Board/Lanes). Backs the
 * admin lane manager in Settings and hands the lane set to the Board API provider.
 * Reads (list) are open to any signed-in user; create / update / reorder / delete
 * are gated server-side by board.manage (Owner / Admin).
 *
 * A lane is { IDBoardLane, Key, Label, Color, SortOrder, IsTerminal }. Key is the
 * stable Status token a card stores; it is set at creation and never edited.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'LaneAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderLaneAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; }
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	// Resolves to an array of lanes (seeded server-side on a tenant's first read).
	listLanes()
	{
		return libFrameworkClient.getJSON(this.fable, this._url('Board/Lanes'))
			.then((pBody) => (pBody && Array.isArray(pBody.Lanes)) ? pBody.Lanes : []);
	}

	createLane(pLabel, pColor, pIsTerminal)
	{
		return this._write(libFrameworkClient.postJSON, 'Board/Lanes', { Label: pLabel || '', Color: pColor || '', IsTerminal: !!pIsTerminal });
	}

	// pPatch is any of { Label, Color, IsTerminal }.
	updateLane(pIDBoardLane, pPatch)
	{
		return this._write(libFrameworkClient.putJSON, 'Board/Lanes/' + (parseInt(pIDBoardLane, 10) || 0), pPatch || {});
	}

	// pOrder is an array of IDBoardLane in the desired left-to-right order.
	reorderLanes(pOrder)
	{
		return this._write(libFrameworkClient.putJSON, 'Board/Lanes/Reorder', { Order: Array.isArray(pOrder) ? pOrder : [] });
	}

	deleteLane(pIDBoardLane)
	{
		return libFrameworkClient.delJSON(this.fable, this._url('Board/Lanes/' + (parseInt(pIDBoardLane, 10) || 0)))
			.then((pJSON) =>
			{
				if (!pJSON || !pJSON.Success) { throw new Error((pJSON && pJSON.Error) || 'Request failed.'); }
				return pJSON;
			});
	}

	_write(pVerb, pPath, pBody)
	{
		return pVerb(this.fable, this._url(pPath), pBody || {})
			.then((pJSON) =>
			{
				if (!pJSON || !pJSON.Success) { throw new Error((pJSON && pJSON.Error) || 'Request failed.'); }
				return pJSON;
			});
	}
}

module.exports = PictProviderLaneAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;
